import { KeyConstructor } from './keyConstructor';
const TRANSLATE_MARKUP_KEY = 'translateMarkup';
export const getTranslateMarkupKey = KeyConstructor(TRANSLATE_MARKUP_KEY);
//# sourceMappingURL=translate.keys.js.map